import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Icon, Button } from 'Components';
import './JobDetails.css';

const JobDetails = ({ onNewJobClick }) => (
  <div>
    <Button onClick={onNewJobClick} className="actions__new-job">
      <div className="actions__new-job__text">
        <div>{i18n.t('common:New Job')}</div>
        <div>{i18n.t('common:based on this')}</div>
      </div>
      <Icon icon="add_circle" />
    </Button>
  </div>
);

JobDetails.propTypes = {
  onNewJobClick: PropTypes.func,
};
export default JobDetails;



// WEBPACK FOOTER //
// ./src/components/Actions/JobDetails/JobDetails.jsx